import React from 'react';
import styled from "styled-components";
import {Link} from "react-router-dom";
import arrowRight from "../../imgs/arrow_right.svg";
import {SText40W700, Text24W500} from "../Typography";

interface ContentLayoutProps {
    backTo?: string;
    title?: string;
    loading?: boolean;
    children: React.ReactNode;
}

const ContentLayout = ({backTo, title, loading, children}: ContentLayoutProps) => {

    return (
        <Wrapper $loading={loading}>
            {backTo && <BackButton as={Link} to={backTo}>
                <ArrowIcon src={arrowRight} alt="Back"/>
                Back
            </BackButton>}
            {title && <Title as={"h1"}>{title}</Title>}
            {children}
        </Wrapper>
    );
}

export default ContentLayout;


const Wrapper = styled.div<{ $loading?: boolean }>`
    box-sizing: content-box;
    max-width: 1200px;
    margin: 0 auto;
    padding: 48px 16px;
    min-height: ${({$loading}) => $loading ? '100vh' : 'unset'};
`;

const BackButton = styled(Text24W500)`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 24px;
    padding-left: 9px;
`;

const ArrowIcon = styled.img`
    width: 5px;
    height: 10px;
    transform: rotate(180deg);
    margin-right: 8px;
`;

const Title = styled(SText40W700)`
    margin-bottom: 24px;
`;
